import NotificationItemTemplate from '../../../ui-kit/components/templates/NotificationItemTemplate'
import ReactionItemTemplate from '../../templates/ReactionItemTemplate'

const ReactionNotification = () => {
  return (
    <NotificationItemTemplate
      graphic={<ReactionItemTemplate size="small" type={'EXCELLENT'} />}
      title="Ernesto Alonso"
      caption="ha reaccionado a tu publicación"
      time="Hace 1 hora"
    />
  )
}

export default ReactionNotification
